function initHaeAnimations() {
  const items = document.querySelectorAll('.js-reveal-animate')

  if (!items.length) return

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      const item = entry.target
      const animation = item.dataset.animation || 'fadeInUp'
      const delay = parseInt(item.dataset.delay || '0', 10)

      setTimeout(() => {
        item.classList.add('is-animated', animation)
        item.style.opacity = '1'
      }, delay)

      obs.unobserve(item)
    })
  }, {
    threshold: 0.2,
  })

  items.forEach((item) => observer.observe(item))
}

initHaeAnimations()